<template>
    <div class="row">
        <div class="col-md-2">
            <navegacion-lateral></navegacion-lateral>
        </div>
        <div class="col-md-10">
            <navegacion-superior></navegacion-superior>
            <div id="formulario" class="mt-4 ms-4 me-4">
                <div class="container text-start">
                    <form>
                        <div class="mt-3 mb-3">
                            <h2 class="pt-3">Registrar Usuario</h2>
                        </div>
                        <div class="row mt-4 mb-4">
                            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                <label for="nombreUsuario" class="form-label">Nombre</label>
                                <input type="text" class="form-control" id="nombreUsuario" aria-describedby="nombreUsuarioAyuda">
                                <div id="nombreUsuarioAyuda" class="form-text">Debes ingresar caracteres alfabéticos.</div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                <label for="aPaternoUsuario" class="form-label">Apellido Paterno</label>
                                <input type="text" class="form-control" id="aPaternoUsuario" aria-describedby="aPaternoUsuarioAyuda">
                                <div id="aPaternoUsuarioAyuda" class="form-text">Debes ingresar caracteres alfabéticos.</div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                <label for="aMaternoUsuario" class="form-label">Apellido Materno</label>
                                <input type="text" class="form-control" id="aMaternoUsuario" aria-describedby="aMaternoUsuarioAyuda">
                                <div id="aMaternoUsuarioAyuda" class="form-text">Debes ingresar caracteres alfabéticos.</div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                                <label for="puestoUsuario" class="form-label">Puesto</label>
                                <input type="text" class="form-control" id="puestoUsuario" aria-describedby="puestoUsuarioAyuda">
                                <div id="puestoUsuarioAyuda" class="form-text">Lorem.</div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                                <label for="emailUsuario" class="form-label">Email</label>
                                <input type="email" class="form-control" id="emailUsuario" aria-describedby="emailUsuarioAyuda">
                                <div id="emailUsuarioAyuda" class="form-text">Debes ingresar un formato válido.</div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                                <label for="empresa" class="form-label">Empresa</label>
                                <select id="empresa" class="form-select" aria-label="Default select example">
                                    <option selected>Seleccione</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                                <label for="empresa" class="form-label">Área</label>
                                <select class="form-select" aria-label="Default select example">
                                    <option selected>Seleccione</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3">
                                <div class="col-sm-12 col-md-6 col-lg-3 mb-3 form-check">
                                    <label class="form-check-label" for="activo">Activo</label><br>
                                    <input type="checkbox" class="form-check-input" id="activo" aria-describedby="activoAyuda"><br>
                                    <div id="activoAyuda" class="form-text">Activo.</div>
                                </div>
                            </div>
                            <div class="col-2 offset-md-7">
                                <button type="submit" class="btn btn-primary w-100 rounded-pill mb-3">Guardar</button>
                            </div> 
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import NavegacionSuperior from "@/Aplicaciones/CCD/Componentes/NavegacionSuperior.vue";
import NavegacionLateral from "@/Aplicaciones/CCD/Componentes/NavegacionLateral.vue";

export default defineComponent({
    name: 'RegistroUsuario',

    components: {
        NavegacionSuperior,
        NavegacionLateral
    }
})
</script>

<style scoped>
    #formulario {
        border-radius: 15px;
        box-shadow: 5px 5px 15px 2px #b2b2b2;
    }

    #activo {
        width: 25px;
        height: 25px;
        margin-left: 10px;
    }

    #activoAyuda {
        margin-top: 20px;
    }
</style>
